import { StickerGridTemplateFactory } from './StickerGridTemplateFactory';

export class StickerGridTemplate3667 extends StickerGridTemplateFactory {
  constructor(emptyStickers) {
    super(
      emptyStickers,
      4,
      16,
      {
        top: 13.3,
        left: 10.2,
      },
      {
        external: {
          horizontal: 0,
          vertical: 0,
        },
        internal: {
          qrLeft: 3,
          qrRight: 0,
          qrTop: 3,
          qrBot: 3,
          label: 1,
          labelTop: 2,
        },
      },
      {
        qr: 10.9,
        labelV: 13.9,
        labelH: 32.6,
        font: 9,
      },
      {
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
      }
    );
  }

  getStickerTotalXSize =
    this.pad.internal.qrLeft +
    this.size.qr +
    this.pad.internal.qrRight +
    this.pad.internal.label +
    this.size.labelH +
    this.pad.internal.label;

  getStickerTotalYSize = this.pad.internal.qrTop + this.size.qr + this.pad.internal.qrBot;

  static getConstructorFunction = emptyStickers => new StickerGridTemplate3667(emptyStickers);
}
